import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { BlogDetailsComponent } from './components/blog-details/blog-details.component';
import { DummyTeacherComponent } from './components/dummy-teacher/dummy-teacher.component';
import { HomePageComponent } from './components/home/home.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SamplePageComponent } from './components/sample-page/sample-page.component';
import { AuthGuard } from './guard/auth.guard';
import { ServiceComponent } from './components/service/service.component';
import { ServiceDetailsComponent } from './components/service-details/service-details.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { PortfolioDetailsComponent } from './components/portfolio-details/portfolio-details.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { ContactSalesComponent } from './components/contact-sales/contact-sales.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  { path: 'sample', component: SamplePageComponent },
  {
    path: 'teachers',
    component: DummyTeacherComponent,
    canActivate: [AuthGuard],
    data: {
      allowedRole: 'ClientAdmin'
    }
  },
  { path: 'about-us', component: AboutUsComponent },
  { path:  'home',component:HomePageComponent},
  { path:  'blog-details',component:BlogDetailsComponent},
  { path:  'service',component:ServiceComponent},
  { path:  'service-details',component:ServiceDetailsComponent},
  { path:  'portfolio',component:PortfolioComponent},
  { path:  'portfolio-details',component:PortfolioDetailsComponent},
  { path:  'contact-us',component:ContactUsComponent},
  { path:  'contact-sales',component:ContactSalesComponent},
  {path:   'sign-up',component:SignUpComponent},



  {
    path: '**', pathMatch: 'full',
    component: NotFoundComponent
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
